module.exports = __webpack_public_path__ + "static/media/delete-blue.5a652ffe.svg";